import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { useTranslation } from 'react-i18next';
import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';

interface FormParams {
  contracts: any[];
  onSubmit: any;
}
function WarehouseContractLineForm(params: FormParams) {
  const { onSubmit, contracts } = params;
  const { t } = useTranslation();

  return (
    <EnhancedForm
      onSubmit={onSubmit}
      formId="addContractLine"
      hideControls
      autoStyleLayout
      columns={2}>
      <>
        {/* Prima riga: solo il campo contract_header */}
        <IdentityField
          gridSpan={2}
          name="contract_header"
          component={AutocompleteAdapter}
          options={contracts}
          label={t('global.contract')}
        />
        {/* Seconda riga: unit_price + initial_available_units */}
        <IdentityField
          name="unit_price"
          component={TextFieldAdapter}
          type="number"
          label={t(`entities.contract_line.unit_price`)}
        />
        <IdentityField
          name="initial_available_units"
          component={TextFieldAdapter}
          type="number"
          label={t(`entities.contract_line.initial_available_units`)}
        />
        {/* Terza riga: initial_discounted_units + iva */}
        <IdentityField
          name="initial_discounted_units"
          component={TextFieldAdapter}
          type="number"
          label={t('entities.contract_line.initial_discounted_units')}
        />
        <IdentityField
          name="iva"
          component={TextFieldAdapter}
          type="number"
          label={t('entities.contract_line.iva')}
        />
      </>
    </EnhancedForm>
  );
}

export default WarehouseContractLineForm;
